// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
import React from 'react';
import ROUTES from '@shared/constants/routes';
import { Item } from '@modules/Private/components/NavigationMenu';
import {
  Customers,
  Staff,
  Assets,
  Orders,
  Dashboard,
  Platforms,
  Vendors,
  Map,
  Grid,
  Measure,
  Wind,
} from '@shared/icons/NavigationMenu';
import AlarmsIcon from '@shared/icons/Alarms';
import Clusters from '@shared/icons/Clusters';
import JobRequestsIcon from '@shared/icons/JobRequests';
import DataManagementIcon from '@shared/icons/DataManagement';
import { ROLES } from '@shared/constants/user';

// Array of items in the side navigation bar.
// Use "roles" and "onlyForHosting" to determine what items will be shown for a certain login.
const MENU_ITEMS: Item[] = [
  {
    name: 'Map',
    route: ROUTES.private.map,
    icon: <Map />,
    roles: [ROLES.pilot, ROLES.observer, ROLES.postProcessingTechnician, ROLES.productionTechnician, ROLES.projectManager, ROLES.customerUser],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Grid',
    route: ROUTES.private.sheets,
    icon: <Grid />,
    roles: [ROLES.pilot, ROLES.observer, ROLES.postProcessingTechnician, ROLES.productionTechnician, ROLES.projectManager, ROLES.customerUser],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Orders',
    route: ROUTES.private.orders,
    icon: <Orders />,
    roles: [ROLES.techSupport],
    onlyForHosting: true,
    isSub: false,
  },
  {
    name: 'Assets',
    route: ROUTES.private.assets,
    icon: <Assets />,
    roles: [ROLES.projectManager],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Customers',
    route: ROUTES.private.customers,
    icon: <Customers />,
    roles: [ROLES.projectManager, ROLES.customerUser],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Vendors',
    route: ROUTES.private.vendors,
    icon: <Vendors />,
    roles: [ROLES.projectManager],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Platforms',
    route: ROUTES.private.platforms,
    icon: <Platforms />,
    roles: [ROLES.projectManager],
    onlyForHosting: true,
    isSub: false,
  },
  {
    name: 'Staff',
    route: ROUTES.private.staff,
    icon: <Staff />,
    roles: [ROLES.projectManager],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Job requests',
    route: ROUTES.private.jobRequests,
    icon: <JobRequestsIcon />,
    roles: [],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Clusters',
    route: ROUTES.private.clusters,
    icon: <Clusters />,
    roles: [ROLES.techSupport],
    onlyForHosting: true,
    isSub: false,
  },
  {
    name: 'File',
    route: ROUTES.private.dataManagement,
    icon: <DataManagementIcon />,
    roles: [ROLES.projectManager],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Alerts',
    route: ROUTES.private.alarms,
    icon: <AlarmsIcon />,
    roles: [],
    onlyForHosting: false,
    isSub: false,
  },
  {
    name: 'Dashboard',
    route: ROUTES.private.dashboard,
    icon: <Dashboard />,
    roles: [],
    onlyForHosting: false,
    isSub: false,
  },
  // {
  //   name: 'iTwins Test',
  //   route: ROUTES.private.iTwinsStorage,
  //   icon: <Grid />,
  //   roles: [ROLES.projectManager, ROLES.customerUser],
  //   onlyForHosting: false,
  //   isSub: false,
  // },
];

export default MENU_ITEMS;